import { Auth } from "aws-amplify";
import { ForgotPassword } from "kh-design-system/components";
import React, { useState } from "react";
import { authentication, authenticationErrors, authenticationModuleNames } from "../../utils/constants";
import { useEvent } from "../../contexts/EventContext";

const ForgotPasswordWrapper = ({
	setEmailValue,
	setSwitchComponent,
	isError,
	setIsError,
	toasterMessage,
	setToasterMessage,
	notificationPopup,
	setNotificationPopup,
	...props
}: {
	setEmailValue: React.Dispatch<React.SetStateAction<string>>;
	setSwitchComponent: React.Dispatch<React.SetStateAction<string>>;
	isError: boolean;
	setIsError: React.Dispatch<React.SetStateAction<boolean>>;
	toasterMessage: string;
	setToasterMessage: React.Dispatch<React.SetStateAction<string>>;
	notificationPopup: boolean;
	setNotificationPopup: React.Dispatch<React.SetStateAction<boolean>>;
	[key: string]: any;
}) => {
	const { eventDetails } = useEvent();
	const primaryColor = eventDetails?.gallery_brand_color;
	const fontFamily = eventDetails?.gallery_font;

	const [loading, setLoading] = useState(false);
	const [signUpError, setSignUpError] = useState("");

	const handleForgotPassword = async (email: string, emailError: string) => {
		setLoading(true);
		if (email && !emailError) {
			try {
				const response = await Auth.forgotPassword(email);
				// Redirect to OTP screen
				if (response) {
					setToasterMessage(authentication.success.OTP_SENT_SUCCESS);
					setNotificationPopup(true);
					setEmailValue(email);
					setLoading(false);
					setTimeout(() => {
						setSwitchComponent(authenticationModuleNames.FORGOT_PASSWORD_OTP);
					}, 700);
				}
			} catch (error) {
				console.error("Error initiating password reset:", error);
				setSignUpError(authentication.error.ERROR_OCCURRED);
				setLoading(false);
			}
		}
	};

	return (
		<>
			<ForgotPassword
				handleForgotPassword={handleForgotPassword}
				onBackClick={() => {
					setSwitchComponent(authenticationModuleNames.SIGN_IN);
				}}
				isLogoVisible={false}
				onClickSignIn={() => {
					setSwitchComponent(authenticationModuleNames.SIGN_IN);
				}}
				loading={loading}
				signUpError={signUpError}
				primaryColor={primaryColor}
				fontFamily={fontFamily}
			/>
		</>
	);
};

export default ForgotPasswordWrapper;
